import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip } from 'reactstrap';
import _ from 'lodash';
import { ProgressButton } from '../../../commons/ProgressButton.js';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Service from './services.js';
import Loader from '../../../commons/loader.js';
import NetworkEmptyState from '../../../commons/networkemptystate.js';
import QueryEmptyState from '../../../commons/queryempty.js';
import DataEmptyState from '../../../commons/dataemptystate.js';
import Lib from '../../../commons/lib.js';
import RFForm from '../../../components/Form/RFForm.js';
import SelectField from '../../../components/Form/SelectField.js';
import RFField from '../../../components/Form/RFField.js';

class ErtesitesLista extends Component {
  constructor(props) {
    super(props);
    this.state = {
      existsSzervezet: false,
      modalNezet: false,
      ertesitesJson: [],
      edit: false,
      modalForm: false,
      modalDelete: false,

      formRaktarak: [],
      formSzemely: [],
      formEmail: null,

      listLoadingButton: false,
      tableStatus: 'QUERY', // [LOAD', NETW', 'LIST', 'QUERY', DATA]

      lekerdezesButtonLoading: false,
      saveButtonLoading: false,
      addButtonLoading: false,
      modifyButtonLoading: false,
      deleteButtonLoading: false,
    };
  }

  componentDidMount() {
    this.updateTable();
    this.checkSzervezetModule();
    this.listRaktar();
  }

  updateTable = () => {
    this.setState({ listLoadingButton: true, tableStatus: 'LOAD' }, () => {
      Service.listErtesites((err, res) => {
        if (!err) {
          this.setState({ 
            ertesitesJson: res[0],
            listLoadingButton: false,
            tableStatus: res[0] && res[0].length > 0 ? 'LIST' : 'DATA',
          });
        } else {
          this.setState({
            listLoadingButton: false,
            tableStatus: err && err.responseJSON && err.responseJSON.hibaazon == 'EMPTY_FILTERS' ? 'QUERY' : 'NETW', 
          });
        }
      });
    });
  }

  checkSzervezetModule = () => {
    Service.existsSzervezet((err, res) => {
      if (!err) {
        this.setState({ existsSzervezet: res[0] });
        if (res[0]) {
          this.listSzemelyek();
        }
      }
    });
  }

  listSzemelyek = () => {
    Service.listSzemelyek((err, res) => {
      if (!err) {
        this.setState({ szemelyJson: res[0] });
      }
    });
  }

  listRaktar = () => {
    Service.queryRaktar(null, (err, res) => {
      if (!err) {
        this.setState({ raktarJson: res[0] });
      }
    });
  }

  deleteErtesites = (id) => {
    this.setState({deleteButtonLoading: true});
    Service.deleteErtesites(id, (err, res) => {
      if (!err) {
        this.updateTable();
        this.handleDeleteClick();
        this.props.globals.addSuccess('Értesítés törölve!');
      }
      this.setState({deleteButtonLoading: false});
    });
  }

  handleModalFormClick = () => {
    this.setState(prevState => ({ modalForm: !prevState.modalForm, edit: false, formId: null, formEmail: null, formSzemely: [], formRaktarak: [] }));
  }

  handleEditClick = (id) => {
    this.setState(prevState => {
      let ertesites = prevState.ertesitesJson.find(x => x.id === id);
      let formRaktarak = Object.entries(ertesites.raktarak).flatMap(raktar => ({ id: raktar[0], nev: raktar[1] }));
      let formSzemely = { id: ertesites.szemelyId, nev: ertesites.szemelyNev };
      return { modalForm: !prevState.modalForm, edit: true, formId: ertesites.id, formEmail: ertesites.email, formSzemely, formRaktarak };
    });
  }

  handleDeleteClick = (id) => {
    if (id) this._currentDeleteId = id;
    this.setState({
      modalDelete: !this.state.modalDelete
    });
  }

  hasKarb = () => {
    return this.props.globals.hasRole(['KESZLETNYILV_KESZLETSZINT'], true);
  }

  iconFormatter = (cell, row) => {
    return (
      <React.Fragment>
        {this.hasKarb() &&
          <>
            <Button className="icon-pencil table-action-icon" id={'ertesites-edit-' + row.id} onClick={() => this.handleEditClick(cell)} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'ertesites-edit-' + row.id} delay={40}> {'Módosítás'} </UncontrolledTooltip>
            <Button className="icon-trash table-action-icon" id={'ertesites-delete-' + row.id} onClick={() => this.handleDeleteClick(cell)} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'ertesites-delete-' + row.id} delay={40}> {'Törlés'} </UncontrolledTooltip>
          </>
        }
        
      </React.Fragment>
    ); 
  }

  submit = (e, submitObj) => {
    submitObj.raktarIds = this.state.formRaktarak?.map(raktar => raktar.id);
    submitObj.szemelyId = this.state.formSzemely?.id;
    submitObj.email = this.state.formEmail;
    if (this.state.edit) {
      submitObj.id = this.state.formId;
      this.setState({saveButtonLoading: true});
      Service.editErtesites(submitObj, (err) => {
        if (!err) {
          this.updateTable();
          this.handleModalFormClick();
          this.props.globals.addSuccess('Értesítés módosítva!');
        }
        this.setState({saveButtonLoading: false});
      });
    } else {
      this.setState({saveButtonLoading: true});
      Service.addErtesites(submitObj, (err) => {
        if (!err) {
          this.updateTable();
          this.handleModalFormClick();
          this.props.globals.addSuccess('Értesítés hozzáadva!');
        }
        this.setState({saveButtonLoading: false});
      });
    }
  }

  renderTable = () => {
    const columns = [
      {
        dataField: 'szemelyNev',
        text: 'Értesítendő személy',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'email',
        text: 'E-mail',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      }, {
        dataField: 'raktarak',
        text: 'Raktár(ak)',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        formatter: raktar => Object.values(raktar).join(', '),
        sort: true
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter
      }
    ];

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.ertesitesJson}
          columns={columns}
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }
 
  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            {this.hasKarb() &&
              <Button className="pull-left table-new-button" color="primary" onClick={this.handleModalFormClick}>Új értesítés</Button>
            }
          </div>
        </div>
        {this.state.tableStatus === 'LOAD' ? <Loader /> : <span />}
        {this.state.tableStatus === 'QUERY' ? <QueryEmptyState hasImage/> : <span />}
        {this.state.tableStatus === 'DATA' ? <DataEmptyState hasImage /> : <span />}
        <div>
          {this.state.tableStatus === 'LIST' ? this.renderTable() : <span />}
          {this.state.tableStatus === 'NETW' ? (
          <NetworkEmptyState
            hasImage
            submitClick={() => this.updateTable()}
          />
          ) : <span />}
        </div>

        <Modal isOpen={this.state.modalDelete} toggle={this.handleDeleteClick} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <ProgressButton loading={this.state.deleteButtonLoading} className="btn-cursor-pointer" color="primary" onClick={() => this.deleteErtesites(this._currentDeleteId)}>OK</ProgressButton>
            <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.handleDeleteClick}>Mégsem</Button>
          </ModalFooter>
        </Modal>

        <RFForm
          onSubmit={this.submit}
          modalInsert
          title={'Értesítés ' + (this.state.edit ? 'módosítása' : 'felvitele')}
          tagProps={{ isOpen: this.state.modalForm, toggle: this.handleModalFormClick, className: this.props.className, backdrop: 'static' }}
          footer={
            <>
              <ProgressButton loading={this.state.saveButtonLoading} className="btn-cursor-pointer" color="primary">Mentés</ProgressButton>{' '}
              <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.handleModalFormClick}>Mégsem</Button>
            </>
          }
        >
          {this.state.existsSzervezet && <div>
            <SelectField
              label='Értesítendő személy:'
              name="szemely"
              id="szemely"
              placeholder="Kezdj el gépelni a kereséshez..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              searchPromptText="Kezdj el gépelni a kereséshez..."
              loadingMessage={() => 'Keresés...'}
              onChange={v => {
                this.setState({ formSzemely: v, formEmail: v?.email });
              }}
              options={this.state.szemelyJson}
              value={this.state.formSzemely}
              defaultOptions
              isClearable
              getOptionValue={option => option.id}
              getOptionLabel={option => option.nev}
            />
          </div>}
          <div className='mt-1'>
            <RFField
              name="email"
              label="E-mail cím:"
              forcedValue={this.state.formEmail}
              onChange={(e, v) => this.setState({ formEmail: v })}
              required
            />
          </div>
          <div>
            <SelectField
              label='Raktár(ak):'
              name='raktarak'
              placeholder="Kezdj el gépelni a kereséshez..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              searchPromptText="Kezdj el gépelni a kereséshez..."
              loadingMessage={() => 'Keresés...'}
              onChange={v => {
                this.setState({ formRaktarak: v });
              }}
              value={this.state.formRaktarak}
              isMulti
              options={this.state.raktarJson}
              getOptionValue={option => option.id}
              getOptionLabel={option => option.nev}
            />
          </div>
        </RFForm>

      </div>
    );
  }
}

export default ErtesitesLista;